var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"cls-1",attrs:{"d":"M1548,141a8,8,0,1,1-8,8A8,8,0,0,1,1548,141Zm4.08,5.384-1.54-1.458-3.9,4.937-2.34-1.989-1.43,1.823,4.48,3.4Z","transform":"translate(-1540 -141)"}})
}
var staticRenderFns = []

export { render, staticRenderFns }